import type { GenerateLinkDto, GenerateLinkRespondentDto, RespondentSurveyLinkDto, SurveyCriteriaDto } from './models';
import { RestService } from '@abp/ng.core';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class GenerateSurveyLinkService {
  apiName = 'Default';

  createSurveyRespondent = (key: string, request: GenerateLinkRespondentDto) =>
    this.restService.request<any, RespondentSurveyLinkDto>({
      method: 'POST',
      url: `/api/culture/surveys-link/${key}`,
      body: request,
    },
    { apiName: this.apiName });

  generateLink = (tenantKey: string, companyKey: string, surveyKey: string) =>
    this.restService.request<any, GenerateLinkDto>({
      method: 'GET',
      url: `/api/culture/surveys-link/generate/${tenantKey}/${companyKey}/${surveyKey}`,
    },
    { apiName: this.apiName });

  getSurveyCriteria = (token: string) =>
    this.restService.request<any, SurveyCriteriaDto[]>({
      method: 'GET',
      url: `/api/culture/surveys-link/selected-criterias/${token}`,
    },
    { apiName: this.apiName });

  constructor(private restService: RestService) {}
}
